import Typography from '@mui/material/Typography';
import { Translate } from '@shared/translation';
import type { TimeZone } from '@shared/utils/date';
import { differenceInDays } from 'date-fns';
import { DateTimeRange } from '../../Date';
import { getActivePreset } from '../Presets';
import type { DateRange, LabeledPreset } from '../types';
import { getPrecision } from './inputFormat';

export interface ValueLabelProps {
  presets?: readonly LabeledPreset[];
  timeZone?: TimeZone;
  value: DateRange;
}

export function ValueLabel({ presets = [], timeZone, value }: ValueLabelProps) {
  const activePreset = getActivePreset(value, { presets, timeZone });

  if (activePreset) {
    return (
      <Translate text={activePreset.label} values={activePreset.labelValues} />
    );
  }

  const precision = getPrecision(value);
  const dateOnly =
    isFullDayRange(value) && differenceInDays(value.to, value.from) > 1;

  return (
    <Typography
      component="span"
      variant="body2"
      noWrap
      sx={{ display: 'block', maxWidth: '100%', lineHeight: 'unset' }}
    >
      <DateTimeRange
        from={value.from}
        to={value.to}
        date={dateOnly ? 'always' : 'auto'}
        time={!dateOnly}
        timeStyle={precision === 'second' ? 'medium' : 'short'}
        timeZone={timeZone}
      />
    </Typography>
  );
}

function isFullDayRange({ from, to }: DateRange) {
  return (
    from.getHours() === 0 &&
    from.getMinutes() === 0 &&
    from.getSeconds() === 0 &&
    to.getHours() === 23 &&
    to.getMinutes() === 59
  );
}
